export { default as ContentfulRenderer } from './contentfulRenderer'
export * from './assetLink'
export * from './contentRow'
export * from './landing'
export * from './responsive'
export * from './touts'
export * from './productQuartet'



// WEBPACK FOOTER //
// ./src/modules/contentful/index.js